import { currencySchema } from "../../../payment/shared.mjs";
import { eventPassSchema, purchaseInputSchema, purchaseResultSchema, userEventPassSchema } from "../payment/eventPass/schemas.mjs";
import { orpcSuccessVoidResponseSchema } from "../util/success.mjs";
import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/event/eventPass.ts
const ListFilter = {
	ALL: "all",
	PURCHASABLE: "purchasable"
};
const listFilterValues = Object.values(ListFilter);
const listFilterSchema = z.enum(listFilterValues);
const listInputSchema = z.object({
	eventName: z.string(),
	currency: currencySchema.optional(),
	filter: listFilterSchema.optional().default(ListFilter.ALL)
});
const resetEventPassesInputSchema = z.object({ eventName: z.string() });
const eventPassContract = oc.prefix("/event/{eventName}/pass").tag("EventPass").router({
	list: oc.route({
		method: "GET",
		path: "/",
		summary: "List available event passes"
	}).input(listInputSchema).output(z.object({ data: z.array(eventPassSchema) })),
	userPasses: oc.route({
		method: "GET",
		path: "/user-passes",
		summary: "Get current user pass records"
	}).input(z.object({ eventName: z.string() })).output(z.object({ data: z.array(userEventPassSchema) })),
	purchase: oc.route({
		method: "POST",
		path: "/purchase",
		summary: "Purchase a pass"
	}).input(purchaseInputSchema).output(purchaseResultSchema).errors({
		EVENT_PASS_NOT_FOUND: {
			status: 404,
			message: "Event pass not found"
		},
		EVENT_NOT_ACTIVE: {
			status: 400,
			message: "Event is not active"
		},
		ALREADY_PURCHASED: {
			status: 409,
			message: "Pass type already owned"
		},
		UPGRADE_NOT_ELIGIBLE: {
			status: 400,
			message: "Must own PREMIUM to upgrade"
		}
	}),
	resetEventPasses: oc.route({
		method: "POST",
		path: "/reset",
		summary: "Delete all user event passes for a given event (admin only)"
	}).input(resetEventPassesInputSchema).output(orpcSuccessVoidResponseSchema)
});
//#endregion
export { ListFilter, eventPassContract };
